// Media rules per platform, mirroring what each Postiz provider can actually publish.
// Shared by the chat post cards (Dashboard) and the Create Post modal (SchedulePostModal).

/** Accepts chat media items ({ url, type }) and modal items ({ isVideo, uploadedUrl }) */
export const isVideoMedia = (m) =>
  !!m && (m.isVideo || m.type === 'video' ||
    // Generated posts default mediaType to 'image', so also check the file extension
    /\.(mp4|mov|m4v|webm)(\?|$)/i.test(m.url || m.uploadedUrl || m.path || ''));

/** Returns a user-facing error when the media breaks the platform's rules, else null */
export const getPlatformMediaError = (platform, mediaItems) => {
  const videoCount = mediaItems.filter(isVideoMedia).length;
  const imageCount = mediaItems.length - videoCount;
  switch (String(platform || '').toLowerCase()) {
    case 'facebook':
      if (videoCount && mediaItems.length > 1) {
        return 'Facebook posts can have several images or a single video, not both. Remove the extra media before posting.';
      }
      return null;
    case 'linkedin':
      if (videoCount && mediaItems.length > 1) {
        return 'LinkedIn posts can have several images or a single video, not both. Remove the extra media before posting.';
      }
      if (imageCount > 20) return 'LinkedIn posts can have at most 20 images. Remove some before posting.';
      return null;
    case 'instagram':
      if (!mediaItems.length) return 'Instagram posts need an image or video. Add media to this post before posting.';
      if (mediaItems.length > 10) return 'Instagram carousels can have at most 10 images or videos. Remove some before posting.';
      return null;
    case 'pinterest':
      if (videoCount > 1) return 'Pinterest pins can have only one video. Remove the extra videos before posting.';
      if (videoCount && imageCount !== 1) {
        return 'Pinterest video pins need exactly one image as the cover, plus the video. Add or remove images before posting.';
      }
      if (imageCount > 5) return 'Pinterest pins can have at most 5 images. Remove some before posting.';
      return null;
    case 'x':
    case 'twitter':
      if (videoCount && mediaItems.length > 1) {
        return 'X posts can have up to 4 images or a single video, not both. Remove the extra media before posting.';
      }
      if (imageCount > 4) return 'X posts can have at most 4 images. Remove some before posting.';
      return null;
    default:
      return null;
  }
};

/** Postiz's Pinterest provider uploads the first item as the video and uses the image as its cover */
export const putVideoFirst = (mediaItems) =>
  [...mediaItems].sort((a, b) => isVideoMedia(b) - isVideoMedia(a));
